/**
 * Regex Utilities
 * 
 * Centralized regex patterns and utilities for text operations
 */

/**
 * Escape special regex characters in a string
 * @param {string} text - Text to escape
 * @returns {string} Escaped text
 */
export const escapeRegex = (text) => {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

/**
 * Create word boundary regex pattern
 * @param {string} searchText - Text to search for
 * @param {boolean} caseSensitive - Whether search should be case-sensitive
 * @returns {RegExp} Regex pattern
 */
export const createWordBoundaryRegex = (searchText, caseSensitive = false) => {
  const escapedSearch = escapeRegex(searchText);
  const flags = caseSensitive ? 'g' : 'gi';
  return new RegExp(`\\b${escapedSearch}\\b`, flags);
};

/**
 * Create simple regex pattern (no word boundaries)
 * @param {string} searchText - Text to search for
 * @param {boolean} caseSensitive - Whether search should be case-sensitive
 * @returns {RegExp} Regex pattern
 */
export const createSimpleRegex = (searchText, caseSensitive = false) => {
  const escapedSearch = escapeRegex(searchText);
  const flags = caseSensitive ? 'g' : 'gi';
  return new RegExp(escapedSearch, flags);
};

export default {
  escapeRegex,
  createWordBoundaryRegex,
  createSimpleRegex,
};

